"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Wait = _interopRequireDefault(require("@rsuite/icon-font/lib/flow/Wait"));

// Generated by script, don't edit it please.
var Wait = (0, _createSvgIcon["default"])({
  as: _Wait["default"],
  ariaLabel: 'wait',
  category: 'flow',
  displayName: 'Wait'
});
var _default = Wait;
exports["default"] = _default;
module.exports = exports.default;